import logo from "../assets/WithShapes2.webp";
import '../css/footer.css';
import { useState } from "react";

const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);


  return (
    <>
      <footer>

        <div className="footerDesktop">
          <div style={{ minWidth: "20px", marginRight: "5px" }}>
            <img src={logo} alt="logo" height="120px" />
          </div>

          <div style={{ color: "white", display: "flex", justifyContent: "center", alignItems: "center" }}>
            &copy; 2025 - All rights reserved • IGRALIS
            {/* &copy; 2025 - All rights reserved • Igralis Žan Mišič s.p. */}
          </div>

          <div style={{ flex: 1, display: "flex", justifyContent: "right", alignItems: "center" }}>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <a className="footerLink" href="https://www.facebook.com/people/Igralis-Games/61581799635221">
                <i className="fab fa-facebook"></i>
              </a>
              <a className="footerLink" href="https://www.instagram.com/igralisgames/">
                <i className="fab fa-instagram"></i>
              </a>
              <a className="footerLink" style={{ marginRight: "20px" }} href="https://x.com/IgralisGames">
                <i className="fab fa-twitter"></i>
              </a>
            </div>

            <div>
              {/* <a className="footerLinkMobile" href="privacy.html">Privacy Policy•</a> */}
              <button data-translate="footerPrivacy" className="privacyButton" onClick={() => setShowPrivacy(true)}>Privacy Policy•</button>
              <a data-translate="footerContact" className="footerLink" href="mailto:contact@igralis.com">Contact•</a>
            </div>
          </div>
        </div>

        <div className="footerMobile">
          <div style={{ flex: "1", alignContent: "center" }}>
            <img src={logo} alt="logo" height="120px" style={{ margin: "5px" }} />
            <p style={{ marginLeft: "10px", color: "white" }}>&copy; 2025 - All rights reserved • IGRALIS</p>
          </div>
          <div className="footerLinks" >
            <div>
              <a className="footerLinkMobileIcon" href="https://www.facebook.com/people/Igralis-Games/61581799635221">
                <i className="fab fa-facebook"></i>
              </a>
              <a className="footerLinkMobileIcon" href="https://www.instagram.com/igralisgames/">
                <i className="fab fa-instagram"></i>
              </a>
              <a className="footerLinkMobileIcon" href="https://x.com/IgralisGames">
                <i className="fab fa-twitter"></i>
              </a>
            </div>
            <br />
            {/* <a className="footerLinkMobile" href="privacy.html">Privacy Policy•</a> */}
            <button data-translate="footerPrivacy" className="privacyButton" onClick={() => setShowPrivacy(true)}>Privacy Policy•</button>

            <br />
            <a data-translate="footerContact" className="footerLink" href="mailto:contact@igralis.com">Contact•</a>
          </div>
        </div>

      </footer>
      {showPrivacy && (
        <div className="privacyBox">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h2 data-translate="privacyTitle">Privacy Policy</h2>
            <button className="xButton" onClick={() => setShowPrivacy(false)}>
              <b>✕</b>
            </button>
          </div>
          <div data-translate="privacyMain">
            <p><strong>Last Updated:</strong> October 31, 2025</p>

            <h2>Data Controller:</h2>
            <p>Igralis Žan Mišič s.p.<br />
              Email: <a style={{ color: "black" }} href="mailto:contact@igralis.com">contact@igralis.com</a></p>

            <p>I am the data controller for this website.</p>

            <h2>1. What Data I Collect</h2>
            <p>I only collect personal data you provide voluntarily via:</p>
            <ul>
              <li>Contact form</li>
              <li>Email</li>
            </ul>
            <p>This may include: your name, email, company name and message content.</p>

            <h2>2. Purpose & Legal Basis</h2>
            <p>I process your data <strong>solely to respond to inquiries or discuss potential projects</strong>.<br />
              The legal bases for processing are:</p>
            <ul>
              <li><strong>Legitimate interest</strong> - responding to your inquiry</li>
              <li><strong>Necessity for contract</strong> - discussing or providing services</li>
            </ul>

            <h2>3. Data Retention</h2>
            <p>I retain your personal data for as long as there is a legitimate business need to communicate or potentially
              collaborate with you, unless you request its deletion. I may also retain data as required to comply with
              legal obligations (e.g., accounting/tax laws).</p>

            <h2>4. Sharing</h2>
            <p>Your data is <strong>never sold or shared</strong> with third parties.</p>

            <h2>5. Your Rights under GDPR & ZVOP-2</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access, correct, or delete your personal data</li>
              <li>Object to or restrict processing</li>
              <li>Request data portability</li>
            </ul>
            <p>To exercise these rights, email me at <a style={{ color: "black" }} href="mailto:contact@igralis.com">contact@igralis.com</a>.</p>

          </div>
        </div>
      )}
    </>
  )
}

export default Footer